module.exports = __webpack_public_path__ + "img/ics_o_pos_active.66af9193.svg";